import { render } from "./JobTitle.vue?vue&type=template&id=2c7bddb2"
import script from "./JobTitle.vue?vue&type=script&lang=js"
export * from "./JobTitle.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tathonglam/docker/src/client/weconcept/star168.hk/star168_backend.git/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__